import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PropTypes } from 'prop-types';
import { GenericDescriptionList } from 'web-ui-components/lib/data/lists';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { renderAddressOrMoveDate, getDateMove, getAvailableAddress } from './getAddressHistory';
import PersonDetailsPage from '../personDetailsSection/PersonDetailsPage';
import { addressSelector } from '../../infrastructure/address';
import { onOfficerValueChange } from '../../infrastructure/officer';
import { Content } from '../../infrastructure/content';
import { getLabelByKey } from '../../utils/businessUtils';
import {
  RESIDENTIAL_STATUS_KEYS,
  OTHER_TITLE
} from '../personDetailsSection/utils/personaDetailsUtils';
import {
  renderForSecondaryComponent,
  renderDirector,
  renderPercentage
} from './signatoriesReviewUtils';

class OfficerComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { isFormEditable: false };
    this.onEditButtonClick = this.onEditButtonClick.bind(this);
  }

  onEditButtonClick() {
    this.setState({ isFormEditable: !this.state.isFormEditable });
  }
  getItems(
    isSoleTrader,
    personDetailsFirstName,
    personDetailsMiddleName,
    personDetailsLastName,
    personDetailsDOB,
    ukAddressTitle,
    dateMove,
    companyDirector,
    percentagePerOwnCompany,
    underPercentage,
    personDetailsResidentialStatus,
    authorizedSignitory,
    officerInfo
  ) {
    const list = [];
    list.push({ key: personDetailsFirstName, value: officerInfo.firstName });

    officerInfo.middleName &&
      list.push({ key: personDetailsMiddleName, value: officerInfo.middleName });

    list.push({ key: personDetailsLastName, value: officerInfo.lastName });
    list.push({
      key: personDetailsDOB,
      value: `${officerInfo.dateOfBirth.dateField}/${officerInfo.dateOfBirth.monthField}/${officerInfo.dateOfBirth.yearField}`
    });

    officerInfo.ukAddress &&
      list.push({ key: ukAddressTitle, value: getAvailableAddress(officerInfo.ukAddress) });
    list.push({ key: dateMove, value: getDateMove(officerInfo.ukAddressDateMove) });
    const addressItem = renderAddressOrMoveDate(officerInfo, true);
    addressItem && list.push(...addressItem);
    const dateMoveItem = renderAddressOrMoveDate(officerInfo, false);
    dateMoveItem && list.push(...dateMoveItem);
    list.push({ key: authorizedSignitory, value: officerInfo.authorisedSignatory });
    !isSoleTrader &&
      list.push(renderPercentage(percentagePerOwnCompany, officerInfo, underPercentage));
    !isSoleTrader && list.push(renderDirector(companyDirector, officerInfo));
    list.push({
      key: personDetailsResidentialStatus,
      value: getLabelByKey(getResidentialStatus(officerInfo), RESIDENTIAL_STATUS_KEYS)
    });

    return list;
  }

  render() {
    const {
      officerInfo,
      addressHistory,
      index,
      removeOfficerDetails,
      linkCode,
      saveOfficerDetails,
      isSoleTrader,
      onOfficerValueChange
    } = this.props;
    const reviewTitle = officerInfo.middleName
      ? `${officerInfo.firstName} ${officerInfo.middleName} ${officerInfo.lastName}`
      : `${officerInfo.firstName} ${officerInfo.lastName}`;
    return (
      <Content>
        {({
          personDetailsFirstName = '',
          personDetailsLastName = '',
          personDetailsDOB = '',
          ukAddressTitle = '',
          dateMove = '',
          authorizedSignitory = '',
          personDetailsResidentialStatus = '',
          percentagePerOwnCompany = '',
          companyDirector = '',
          underPercentage = '',
          personDetailsMiddleName = ''
        }) => (
          <div>
            <SectionHeading>{`${getTitle(officerInfo)} ${reviewTitle}`}</SectionHeading>

            {this.state.isFormEditable ? (
              <PersonDetailsPage
                savePersonDetails={v => {
                  saveOfficerDetails(v, index, officerInfo.officer_id);
                  this.onEditButtonClick();
                }}
                officerInfo={officerInfo}
                currentOfficerNumber={index}
                onOfficerValueChange={onOfficerValueChange}
                addressHistory={addressHistory}
                isSoleTrader={isSoleTrader}
              />
            ) : !linkCode ? (
              <div>
                <GenericDescriptionList
                  items={this.getItems(
                    isSoleTrader,
                    personDetailsFirstName,
                    personDetailsMiddleName,
                    personDetailsLastName,
                    personDetailsDOB,
                    ukAddressTitle,
                    dateMove,
                    companyDirector,
                    percentagePerOwnCompany,
                    underPercentage,
                    personDetailsResidentialStatus,
                    authorizedSignitory,
                    officerInfo
                  )}
                />

                {!linkCode && (
                  <NavigationButton.Tertiary
                    labelText={this.state.isFormEditable ? 'Cancel Editing' : 'Edit'}
                    onClick={e => {
                      e.preventDefault();
                      this.onEditButtonClick();
                    }}
                  />
                )}
                {!linkCode && (
                  <NavigationButton.Tertiary
                    labelText="Remove"
                    onClick={e => {
                      e.preventDefault();
                      removeOfficerDetails(index, officerInfo.officer_id);
                    }}
                  />
                )}
              </div>
            ) : (
              renderForSecondaryComponent(
                authorizedSignitory,
                officerInfo,
                percentagePerOwnCompany,
                underPercentage,
                companyDirector,
                isSoleTrader
              )
            )}
          </div>
        )}
      </Content>
    );
  }
}

OfficerComponent.propTypes = {
  officerInfo: PropTypes.array
};

const actionCreators = {
  onOfficerValueChange
};
const mapStateToProps = (state, ownProps) => ({
  addressHistory: addressSelector.noOfAddresses(state, ownProps.index)
});
const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

const getResidentialStatus = values =>
  values.residentialStatus && values.residentialStatus.toLowerCase() === 'other'
    ? values.residentialStatusOther
    : values.residentialStatus;

export const getTitle = values =>
  values.title && values.title.toLowerCase() === 'other'
    ? getLabelByKey(values.titleOther, OTHER_TITLE)
    : values.title;

export default connect(mapStateToProps, mapDispatchToProps)(OfficerComponent);
